export const SERVER_URL = "https://brutaltreningsuplementi-server.onrender.com/"


export const DATA_STATE = {
	DATA_STATE_OK: "DATA_STATE_OK",
	DATA_STATE_LOADING: "DATA_STATE_LOADING",
};

export const NOTIFICATION_TYPES = {
	STANDARD: "STANDARD",
	SUCCESS: "SUCCESS",
	ERROR: "ERROR",
};
